import { Injectable } from '@angular/core';
import {
  PaymentMethodDto,
  PaymentMethodMetaModel,
  PaymentMethodResourceService
} from '@well/company-libs/payment-method/shell-api';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {
  constructor(private service: PaymentMethodResourceService) { }
  getPaymentMethodTemplateAtSignup(subscriptionTypeUuid: string): Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>> {
    return this.service.getPaymentMethodTemplateAtSignup(subscriptionTypeUuid);
  }

  savePaymentMethodAtSignup(dto: PaymentMethodDto): Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>> {
    return this.service.savePaymentMethodAtSignup(dto);
  }

}
